module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// ./~/stream-browserify/~/readable-stream/transform.js
// module id = 419
// module chunks = 0